import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import {
  Close as CloseIcon,
  Reply as ReplyIcon,
} from "@mui/icons-material";
import { MEDIA_URL } from "src/network/endpoints";

const ReplyPreview = React.memo(({ replyPreview, onCancelReply }) => {
  if (!replyPreview?.isActive || !replyPreview?.message) return null;

  const { message } = replyPreview;

  return (
    <Box
      sx={{
        padding: { xs: 1.5, sm: 2 },
        borderTop: (theme) => `1px solid ${theme.palette.divider}`,
        backgroundColor: "#f2ebfd",
        borderLeft: "4px solid #7C3AED",
        position: { xs: "fixed", md: "relative" },
        bottom: { xs: "64px", md: "auto" },
        left: { xs: 0, md: "auto" },
        right: { xs: 0, md: "auto" },
        width: { xs: "100%", md: "auto" },
        zIndex: { xs: 9998, md: "auto" },
        boxShadow: "0 2px 8px rgba(124, 58, 237, 0.1)",
        transition: "all 0.3s ease",
        animation: "slideUp 0.3s ease-in-out",
        "@keyframes slideUp": {
          "0%": {
            opacity: 0,
            transform: "translateY(20px)",
          },
          "100%": {
            opacity: 1,
            transform: "translateY(0)",
          },
        },
        "&:hover": {
          backgroundColor: "#e6d7fc",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          gap: 2,
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              mb: 0.5,
            }}
          >
            <ReplyIcon
              sx={{
                fontSize: { xs: "0.7rem", sm: "0.75rem" },
                color: "#7C3AED",
              }}
            />
            <Typography
              variant="caption"
              sx={{
                color: "#7C3AED",
                fontWeight: 600,
                fontSize: { xs: "0.7rem", sm: "0.75rem" },
                textTransform: "lowercase",
              }}
            >
              replying to {message.isOwn ? "yourself" : message.sender || "user"}
            </Typography>
          </Box>
          
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              gap: 1,
              maxWidth: "100%",
            }}
          >
            {message.attachments && 
             message.attachments.length > 0 && (
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: 1,
                  overflow: "hidden",
                  flexShrink: 0,
                  backgroundColor: "#f3f4f6",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "1px solid #e5e7eb",
                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                }}
              >
                {message.attachments[0].type === "image" ? (
                  <img
                    src={message.attachments[0].url.startsWith('http') 
                      ? message.attachments[0].url 
                      : `${MEDIA_URL}${message.attachments[0].url}`}
                    alt="media"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                ) : message.attachments[0].type === "video" ? (
                  <Box
                    sx={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#6b7280",
                    }}
                  >
                    📹
                  </Box>
                ) : (
                  <Box
                    sx={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#6b7280",
                    }}
                  >
                    📎
                  </Box>
                )}
              </Box>
            )}
            
            <Typography
              variant="body2"
              sx={{
                color: "#374151",
                fontSize: { xs: "0.8rem", sm: "0.875rem" },
                fontWeight: 400,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                maxWidth: "100%",
                flex: 1,
              }}
            >
              {message.text || 
               (message.attachments && message.attachments.length > 0 
                ? `${message.attachments.length} media` 
                : "message")}
            </Typography>
          </Box>
        </Box>
        
        <IconButton
          size="small"
          onClick={onCancelReply}
          sx={{
            width: 28,
            height: 28,
            color: "#6b7280",
            backgroundColor: "rgba(0, 0, 0, 0.05)",
            border: "1px solid rgba(0, 0, 0, 0.1)",
            "&:hover": {
              backgroundColor: "rgba(124, 58, 237, 0.1)",
              color: "#7C3AED",
              borderColor: "rgba(124, 58, 237, 0.3)",
              transform: "scale(1.05)",
            },
            transition: "all 0.2s ease",
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
});

export default ReplyPreview;
